var map = {
	"./battery_4blue.png": "1a4c",
	"./battery_4classic.png": "bd6d",
	"./battery_4disable.png": "829c",
	"./battery_4green.png": "2e4c",
	"./battery_4orange.png": "bab9",
	"./battery_4purple.png": "028c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1d006";